import { render, staticRenderFns } from "./edit-case.vue?vue&type=template&id=03f0f10c&scoped=true&"
import script from "./edit-case.vue?vue&type=script&lang=js&"
export * from "./edit-case.vue?vue&type=script&lang=js&"
import style0 from "./edit-case.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./edit-case.vue?vue&type=style&index=1&id=03f0f10c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03f0f10c",
  null
  
)

export default component.exports